import { useMemo, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CustomPagination from "../../../shared/CustomPagination";
import { useMutation, useQuery } from "react-query";
import { deleteFn, getFn } from "../../../Services/sharedGeneralFn";
import { API_URLS } from "../../../config/apiUrls";
import AddProductVariantType from "./AddProductVariant";
import { DeleteForever, Edit } from "@mui/icons-material";
import ConfirmationDialog from "../../../shared/ConfirmationDialog";
import { toast } from "react-toastify";
import { Button } from "@mui/material";

const ProductStorage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [editVariantType, setEditVariantType] = useState();

  const { data: typeThreeCategoriesDirty, refetch } = useQuery(
    ["typeThreeCategories", searchQuery, page],
    () => getFn({ page, search: searchQuery }, API_URLS.otherTypeApi)
  );

  const typeThreeCategories = useMemo(
    () => typeThreeCategoriesDirty?.data?.data,
    [typeThreeCategoriesDirty?.data?.data]
  );

  const { mutate: deleteCategoryType } = useMutation(
    (id) => deleteFn({ variant_ids: [id] }, API_URLS.otherTypeApi),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          refetch();
        } else {
          toast.error(res.data.message);
        }
      },
    }
  );

  const handleDelete = (id) => {
    deleteCategoryType(id);
  };

  return (
    <div className="bg-slate-100">
      <div className="flex justify-between bg-slate-100">
        <div className="p-2">
          <p className="text-xl font-bold text-black font">
            Other Variant List (Type Three)
          </p>
        </div>
      </div>

      <div className="flex flex-col !my-3 !rounded  bg-dark bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between p-2 h-14 border-zinc-600">
          <div className="flex">
            <input
              type="text"
              className="!border-3 !border-black !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </div>
          <AddProductVariantType
            editVariantType={editVariantType}
            setEditVariantType={setEditVariantType}
          />
        </div>

        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {["ID", "Type Three", "Category Name", "Actions"].map(
                  (header, idx) => {
                    return (
                      <TableCell
                        key={idx}
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                        className="!text-center !text-gray-800 !font-bold"
                      >
                        {header}
                      </TableCell>
                    );
                  }
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {typeThreeCategories &&
                typeThreeCategories.map((row, idx) => (
                  <TableRow
                    key={idx}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.title}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.category_name}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Button
                        className="!min-w-fit"
                        onClick={() => setEditVariantType(row)}
                      >
                        <Edit className="text-green-500 cursor-pointer" />
                      </Button>
                      <ConfirmationDialog
                        title="Are you sure you want to delete this variant?"
                        description="This will permanently remove the selected variant from the database."
                        onConfirm={() => handleDelete(row?.id)}
                      >
                        <DeleteForever className="text-red-500 cursor-pointer" />
                      </ConfirmationDialog>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <CustomPagination data={typeThreeCategoriesDirty} setPage={setPage} />
      </div>
    </div>
  );
};

export default ProductStorage;
